import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import bnTranslations from './Assets/Translations/bn.json';
import enTranslations from './Assets/Translations/en.json';

const selected_lang = localStorage.getItem('language')

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations,
      },
      bn: {
        translation: bnTranslations,
      },
    },
    lng: selected_lang ||'en', // default language
    fallbackLng: 'en',

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
